module.exports = __webpack_public_path__ + "assets/touxiang3.5b194171c524d229fb27b1b90b878dd0.png";